<template>
<div class="wrap">
  <div class="projectInfo"  v-if="showPc!='pc' && !showPc">
    <shareMobile />
  </div>

  <div v-if="showPc!='pc' && showPc">
    <newShareInfo />
  </div>
  
</div>
</template>

<script>
import newShareInfo from '../../newShareInfo'
import shareMobile from '../../shareMobile'
export default {
  components: {
    newShareInfo,
    shareMobile
  },
  data() {
    return {
      showPc: "pc"
    }
  },
  mounted() {
    if(screen.width>768){
      this.showPc = true
    }else{
      this.showPc = false
    }
  },
  methods: {
  },
}
</script>

<style lang="less">
.DisclaimerDiv{
  .van-dialog__message{
    overflow: hidden;
    text-align: left;
    max-height: 250px;
    overflow-y: scroll;
  }
}
.wrap{
  height: 100%;
.projectInfo {
}
}
</style>


// WEBPACK FOOTER //
// src/page/items/page/info.vue